<template>
    <div class="yandex-map-3-hint">
        <div class="yandex-map-3-hint__title"></div>
        <div class="yandex-map-3-hint__text"></div>
    </div>
</template>

<style lang="scss">
.yandex-map-3-hint {
    user-select: none;
    background-color: white;
    border: 1px solid rgba(0, 0, 0, 0.3);
    font-size: 12px;
    padding: 4px 6px;
    transform: translate(15px, 15px);
}
</style>